import { cx, mediaQueries } from '@eti/styles';
import { m as motion } from 'framer-motion';
import Media from 'react-media';
import { constants, string as stringUtils } from '@eti/utils';
import { useRef } from 'react';
import { Text, textVariants } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { useProductSnowplowTracking } from '../../../custom-hooks/useProductSnowplowTracking';
import { useProductCardContext } from '../../context/ProductCardContext';
import SingleChoiceField from './SingleChoice/SingleChoiceField';
import { priceLabelStyles, priceStyles, priceWrapperStyles, standardGrid, animationProps } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonContainer = _ref => {
  let {
    customGrid,
    children,
    className
  } = _ref;
  const {
    price,
    priceLabel,
    productName,
    priceSuffix,
    productPosition,
    travelers
  } = useProductCardContext();
  const priceToDisplay = priceSuffix && priceSuffix !== '' ? stringUtils.insertArgument(priceSuffix, price) : price;
  const rootElement = useRef(null);
  const {
    sendAddToCartEvent,
    updateContext
  } = useProductSnowplowTracking(productName, {
    rootElement,
    sendSeenEvent: false
  });
  const handleOnChange = async value => {
    const travelersWithoutInfants = travelers === null || travelers === void 0 ? void 0 : travelers.filter(_ref2 => {
      let {
        ageType
      } = _ref2;
      return ageType !== constants.ageTypes.INFANT;
    });
    await updateContext({
      position: productPosition,
      quantity: travelersWithoutInfants === null || travelersWithoutInfants === void 0 ? void 0 : travelersWithoutInfants.length
    });
    sendAddToCartEvent({
      addToCart: value === 'true'
    });
  };
  return /*#__PURE__*/_jsx(Media, {
    query: mediaQueries.small.only,
    children: isMobile => /*#__PURE__*/_jsxs(motion.div, {
      ...animationProps(isMobile),
      className: cx(priceWrapperStyles, className, customGrid || standardGrid),
      "data-testid": `${productName}-product-selection`,
      ref: rootElement,
      children: [/*#__PURE__*/_jsx(motion.div, {
        className: cx(priceLabelStyles, 'price__label', 'priceLabel'),
        ...animationProps(isMobile),
        children: /*#__PURE__*/_jsx(Text, {
          children: priceLabel
        })
      }), /*#__PURE__*/_jsxs(motion.div, {
        className: cx(priceStyles, 'product-price', 'price'),
        ...animationProps(isMobile),
        children: [/*#__PURE__*/_jsx(Text, {
          "aria-hidden": true,
          "data-testid": `${productName}-price`,
          variant: textVariants._18_EMPHASIZED,
          children: priceToDisplay
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: priceToDisplay
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "children",
        children: children || /*#__PURE__*/_jsx(SingleChoiceField, {
          onChange: handleOnChange
        })
      })]
    })
  });
};
export default ButtonContainer;
//# sourceMappingURL=ButtonContainer.js.map